import type { ScenarioAttributeNode } from '../../../features/scenarios/api';
import type { HierarchicalOption } from '../../common/HierarchicalSelect';

// 旧映像スタイルの読み取り互換。選択肢や指示本文はDB属性ツリーが正本。
export const LEGACY_SHOOTING_STYLES = new Set(['point_of_view', 'selfie']);

export function findShootingMethodLabel(options: HierarchicalOption[], key: string): string | undefined {
  for (const option of options) {
    if (option.type === 'option' && option.key === key) return option.label;
    const label = findShootingMethodLabel(option.children ?? [], key);
    if (label !== undefined) return label;
  }
}

export function splitShootingMethod(values?: Record<string, unknown> | null) {
  const style = typeof values?.visual_style === 'string' && values.visual_style
    ? values.visual_style : 'photorealistic';
  const legacy = LEGACY_SHOOTING_STYLES.has(style);
  const raw = values && Object.prototype.hasOwnProperty.call(values, 'shooting_method')
    ? values.shooting_method : legacy ? style : '';
  return {
    visualStyle: legacy ? 'photorealistic' : style,
    shootingMethod: typeof raw === 'string' && raw !== 'none' ? raw.trim() : '',
  };
}

export function deriveShootingMethodOptions(items?: ScenarioAttributeNode[]) {
  const find = (nodes: ScenarioAttributeNode[], key: string): ScenarioAttributeNode | undefined => {
    for (const node of nodes) {
      if (node.key === key) return node;
      const found = find(node.children ?? [], key);
      if (found) return found;
    }
  };
  const field = find(items ?? [], 'shooting_method');
  const toOptions = (nodes: ScenarioAttributeNode[], legacy: boolean): HierarchicalOption[] =>
    nodes.flatMap((node): HierarchicalOption[] => {
      const children = toOptions(node.children ?? [], legacy);
      if (node.node_type === 'group') return children.length
        ? [{ id: node.id, key: node.key, label: node.label, type: 'group', children }] : [];
      if (node.node_type !== 'option' || (legacy && !LEGACY_SHOOTING_STYLES.has(node.key))) return [];
      return [{ id: node.id, key: node.key, label: node.label, type: 'option' }];
    });
  return {
    shootingMethodOptions: toOptions(field?.children ?? find(items ?? [], 'visual_style')?.children ?? [], !field),
    shootingMethodFieldPlacement: (field?.placement === 'advanced' ? 'advanced' : 'primary') as 'primary' | 'advanced',
  };
}
